/* eslint-disable no-unused-vars */
import React from 'react';

const StructuredData = () => {
    const organizationSchema = {
        '@context': 'https://schema.org',
        '@type': 'Organization',
        name: 'Burns Consulting Partners',
        url: 'https://burnscp.com',
        logo: 'https://burnscp.com/favicon.svg',
        description: 'Enterprise technology solutions provider specializing in custom software, AI, cybersecurity, and cloud migration for government and enterprise clients.',
        contactPoint: {
            '@type': 'ContactPoint',
            contactType: 'Customer Service',
            email: 'contact@burnscp.com',
        },
        sameAs: [
            // Add social media links here when available
        ],
    };

    const serviceSchema = {
        '@context': 'https://schema.org',
        '@type': 'Service',
        serviceType: 'Enterprise Technology Consulting',
        provider: {
            '@type': 'Organization',
            name: 'Burns Consulting Partners',
        },
        areaServed: {
            '@type': 'Country',
            name: 'United States',
        },
        hasOfferCatalog: {
            '@type': 'OfferCatalog',
            name: 'Enterprise Technology Services',
            itemListElement: [
                {
                    '@type': 'Offer',
                    itemOffered: {
                        '@type': 'Service',
                        name: 'Custom Software Development',
                    },
                },
                {
                    '@type': 'Offer',
                    itemOffered: {
                        '@type': 'Service',
                        name: 'Cloud Migration Services',
                    },
                },
                {
                    '@type': 'Offer',
                    itemOffered: {
                        '@type': 'Service',
                        name: 'Cybersecurity Solutions',
                    },
                },
                {
                    '@type': 'Offer',
                    itemOffered: {
                        '@type': 'Service',
                        name: 'AI and Machine Learning',
                    },
                },
            ],
        },
    };

    const faqSchema = {
        '@context': 'https://schema.org',
        '@type': 'FAQPage',
        mainEntity: [
            {
                '@type': 'Question',
                name: 'What types of enterprise clients do you work with?',
                acceptedAnswer: {
                    '@type': 'Answer',
                    text: 'We work with government agencies, large enterprises, and mid-size organizations across various industries including healthcare, finance, and technology. Our solutions are designed to meet the unique needs of mission-critical systems.',
                },
            },
            {
                '@type': 'Question',
                name: 'How do you ensure data security and compliance?',
                acceptedAnswer: {
                    '@type': 'Answer',
                    text: 'We implement industry-leading security practices including end-to-end encryption, comprehensive data governance, automated backups, and disaster recovery. Our solutions are designed to meet GDPR, HIPAA, and FedRAMP requirements.',
                },
            },
            {
                '@type': 'Question',
                name: 'What is your typical project timeline?',
                acceptedAnswer: {
                    '@type': 'Answer',
                    text: 'Project timelines vary based on scope and complexity. We follow an agile methodology with regular milestones and deliverables. Most enterprise projects range from 3-12 months, with ongoing support and maintenance available.',
                },
            },
            {
                '@type': 'Question',
                name: 'Do you provide ongoing support and maintenance?',
                acceptedAnswer: {
                    '@type': 'Answer',
                    text: 'Yes, we offer comprehensive support and maintenance services including 24/7 monitoring, regular updates, security patches, and technical support. We provide SLAs to ensure your systems remain operational and secure.',
                },
            },
            {
                '@type': 'Question',
                name: 'What cloud platforms do you work with?',
                acceptedAnswer: {
                    '@type': 'Answer',
                    text: 'We have expertise in AWS, Azure, and Google Cloud Platform. We can help with cloud migration, architecture design, and ongoing cloud management. Our solutions support multi-region deployments for high availability.',
                },
            },
            {
                '@type': 'Question',
                name: 'How do you handle project communication and reporting?',
                acceptedAnswer: {
                    '@type': 'Answer',
                    text: 'We maintain transparent communication through regular status updates, sprint reviews, and stakeholder meetings. You will have access to project dashboards and detailed reports on progress, milestones, and metrics.',
                },
            },
        ],
    };

    const breadcrumbSchema = {
        '@context': 'https://schema.org',
        '@type': 'BreadcrumbList',
        itemListElement: [
            {
                '@type': 'ListItem',
                position: 1,
                name: 'Home',
                item: 'https://burnscp.com/',
            },
            {
                '@type': 'ListItem',
                position: 2,
                name: 'Contact',
                item: 'https://burnscp.com/page-contact',
            },
        ],
    };

    return (
        <>
            <script
                type="application/ld+json"
                dangerouslySetInnerHTML={{
                    __html: JSON.stringify(organizationSchema),
                }}
            />
            <script
                type="application/ld+json"
                dangerouslySetInnerHTML={{
                    __html: JSON.stringify(serviceSchema),
                }}
            />
            <script
                type="application/ld+json"
                dangerouslySetInnerHTML={{
                    __html: JSON.stringify(faqSchema),
                }}
            />
            <script
                type="application/ld+json"
                dangerouslySetInnerHTML={{
                    __html: JSON.stringify(breadcrumbSchema),
                }}
            />
        </>
    );
};

export default StructuredData;

